<article class="case-card rounded-3xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
  <div class="case-card__header rounded-2xl border border-slate-100 px-4 py-3">
    <div class="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div class="min-w-0">
        <div class="flex flex-wrap items-center gap-2">
          <h3 class="truncate text-lg font-semibold text-slate-900">
            Case {{ caseItem().caseUniqueId || caseItem().id }}
          </h3>
          <app-status-badge [status]="caseItem().status" size="sm" />
        </div>
      </div>

      <div class="flex flex-wrap gap-2">
        <a
          [routerLink]="['/clients', caseItem().clientId, 'case', caseItem().id]"
          class="rounded-xl border border-(--color-secondary) bg-(--color-secondary) px-3 py-2 text-sm font-medium text-white transition hover:opacity-90"
        >
          Case Page
        </a>
      </div>
    </div>
  </div>

  <dl class="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
    <div class="case-card__datum">
      <dt class="case-card__label">Case Opened On</dt>
      <dd class="case-card__value">{{ caseItem().openedDate }}</dd>
    </div>

    <div class="case-card__datum">
      <dt class="case-card__label">Case Closed On</dt>
      <dd class="case-card__value">{{ caseItem().closeDate || '—' }}</dd>
    </div>

    <div class="case-card__datum">
      <dt class="case-card__label">Service Name</dt>
      <dd class="case-card__value">{{ caseItem().serviceName }}</dd>
    </div>

    <div class="case-card__datum">
      <dt class="case-card__label">Partner Assigned</dt>
      <dd class="case-card__value">{{ caseItem().partnerName }}</dd>
    </div>

    <div class="case-card__datum">
      <dt class="case-card__label">Total Hours Logged on Case</dt>
      <dd class="case-card__value">{{ caseItem().totalHours }}</dd>
    </div>

    <div class="case-card__datum">
      <dt class="case-card__label">Total Service Unit of Measure</dt>
      <dd class="case-card__value">{{ caseItem().totalUnits }} {{ caseItem().unitLabel }}</dd>
    </div>
  </dl>

</article>